import { useMemo, useState } from "react";

import type { Frequency , BeneficiaryItem } from "../../types";
import getDefaultAmount from "./getDefaultAmount";

const useAmountByKey = (items: BeneficiaryItem[], distributionFrequency: Frequency, shouldRoundCents: boolean) => {
  const [ customAmountByKey, setCustomAmountByKey ] = useState<Record<string, number>>({});

  const amountByKey = useMemo(() =>
    items.reduce<Record<string, number>>((accumulator, item) => {
      accumulator[item.key] = customAmountByKey[item.key] !== undefined
        ? customAmountByKey[item.key]
        : getDefaultAmount(item, distributionFrequency, shouldRoundCents);

      return accumulator;
    }, {})
  , [ items, customAmountByKey, distributionFrequency, shouldRoundCents ]);

  return { amountByKey, customAmountByKey, setCustomAmountByKey };
};

export default useAmountByKey;
